<template>
  <v-app-bar
    class="justify-space-between appbar"
    color="#ffffff"
    elevation="1"
    elevate-on-scroll
    fixed
    height="60"
  >
    <v-toolbar-title>
      <router-link
        class="text-decoration-none"
        :to="{ name: $consts.ROUTES.HOME.NAME }"
      >
        <v-img :src="logo"></v-img>
      </router-link>
    </v-toolbar-title>
    <Navbar
      :links="links"
      :login-modal="loginModal"
      :register-modal="registerModal"
    />
    <v-spacer></v-spacer>
    <div class="appbar-buttons">
      <Button
        class="sign-in"
        background-color="#ffffff"
        border-color="#ee396c"
        font-color="#ee396c"
        @click="loginModal"
      >
        Acessar Conta
      </Button>
      <Button
        class="sign-up"
        @click="registerModal"
      >
        Criar Conta
      </Button>
    </div>
  </v-app-bar>
</template>

<script>
import Button from '@/components/Button/Button.vue';
import Navbar from '@/components/Header/Navbar.vue';
import IdleService from '@/services/IdleService';
import RegisterMixin from '@/mixins/RegisterMixin';

export default {
  name: 'Header',
  components: {
    Button,
    Navbar,
  },
  mixins: [RegisterMixin],
  data() {
    return {
      logo: require('../../assets/spitiart-logo.svg'),
      links: [
        { name: 'Leilões', clickMethod: () => this.gotoRoute(this.$consts.ROUTES.LEILOES.NAME) },
        {
          name: 'Calendário',
          clickMethod: () => this.gotoRoute(this.$consts.ROUTES.CALENDARIO.NAME),
        },
        { name: 'Eventos', clickMethod: () => this.gotoRoute(this.$consts.ROUTES.EVENTOS.NAME) },
        { name: 'Artistas', clickMethod: () => this.gotoRoute(this.$consts.ROUTES.ARTISTAS.NAME) },
      ],
    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    userData() {
      return this.$store.state.Data.User.profile;
    },
  },
  created() {
    // UserService.retriverProfileInfo();
    this.$bus.on(this.$events.GET_PARTNER, () => {
      // UserService.retriverProfileInfo();
    });
  },
  beforeCreate() {
    IdleService.init();
  },
  beforeDestroy() {
    IdleService.destroy();
  },
  methods: {
    gotoRoute(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.collapse-menu {
  display: none;
}

@media only screen and (max-width: 1024px) and (max-height: 768px) {
  .collapse-menu {
    display: block;
  }
}

.appbar {
  padding: 0 60px;
  z-index: 100;
  @media (max-width: $lg) {
    padding: 0 20px;
  }

  &-buttons {
    margin: 0;
    button {
      &.sign-in {
        @media (max-width: $lg) {
          display: none;
        }
      }
      &.sign-up {
        @media (max-width: 420px) {
          display: none;
        }
      }
      & + button {
        margin-left: 12px;
      }
    }
  }
}
</style>
